// External dependencies
import { ConnectedRouter } from 'connected-react-router'
import React, { Suspense } from 'react'
import { Provider } from 'react-redux'
import { history, store } from 'store'
import { BreakpointProvider } from 'utils/hoc/breakpointProvider'
import ScrollToTop from 'utils/hoc/scrollToTop'
import PathByI18nSwitcher from 'components/PathByI18nSwitcher'
import Seo from 'components/Seo'
import UseDesk from 'components/UseDesk'
import AuthWrapper from 'modules/Auth'
import Panels from 'modules/Panels'

const CookieBanner = React.lazy(() => import('components/CookieBanner'))
const Modal = React.lazy(() => import('components/Modal'))
const Notifications = React.lazy(() => import('modules/Notifications'))

const App = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <PathByI18nSwitcher />
      <Seo />
      <BreakpointProvider>
        <AuthWrapper />
        <Panels />
        <Suspense fallback={<></>}>
          <Modal />
        </Suspense>
        <Suspense fallback={<></>}>
          <CookieBanner />
        </Suspense>
      </BreakpointProvider>
      <Suspense fallback={<></>}>
        <Notifications />
      </Suspense>
      <ScrollToTop />
    </ConnectedRouter>
    <UseDesk />
  </Provider>
)

export default App
